import { FeatureType, type Hotspot } from '@types';
import { getPrevSceneId, getNextSceneId } from '@modules/category';
import { $sceneMap } from '@stores/dataStores';
import { $loadedId } from '@stores/loadedStore';

/**
 * 获取热点标题, 用于特殊处理上/下一场景类型的热点
 */
export function modifyHotspotTItle(hotspot: Hotspot): Hotspot {
  if (hotspot.title) return hotspot;
  if (hotspot.data.code === FeatureType.prevScene) {
    const prevId = getPrevSceneId($loadedId.getState()!, {
      ignoreHidden: hotspot.data.skipThumbHidden === 1,
    });
    const sceneName = $sceneMap.getState().get(prevId)?.name;
    return { ...hotspot, title: sceneName ?? '' };
  }
  if (hotspot.data.code === FeatureType.nextScene) {
    const nextId = getNextSceneId($loadedId.getState()!, {
      ignoreHidden: hotspot.data.skipThumbHidden === 1,
    });
    const sceneName = $sceneMap.getState().get(nextId)?.name;
    return { ...hotspot, title: sceneName ?? '' };
  }
  return hotspot;
}
